<div class="container-fluid">

  <div class="row" [formGroup]="form">
    <div class="col-md-12">
      <div class="form-group">
        <label class="form-grid-item" for="description">Bezeichnung*</label>
        <input type="text" placeholder="Name" class="form-control form-grid-item" formControlName="description" id="description">
        @if (form.get('description').hasError('required') && form.get('description').touched) {
          <div class="input-error">Bezeichnung wird benötigt</div>
        }
      </div>
      <div class="form-group">
        @if (mode === 'add') {
          <div class="center mb-4">
            <p-fileUpload #fileUpload
              [auto]="true"
              [customUpload]="true"
              (uploadHandler)="onSelect($event)"
              [maxFileSize]="maxFileSize"
              [showUploadButton]="false"
              [showCancelButton]="false"
              chooseLabel="selektieren"
              styleClass="upload-dropzone">
              <ng-template pTemplate="empty">
                <p class="upload-dropzone-text">
                  <i class="fa fa-arrow-circle-o-up"></i>
                  Datei hier ablegen, oder <a class="cursor-pointer" (click)="chooseFile()">selektieren</a>. Max 3.5 MB
                </p>
              </ng-template>
            </p-fileUpload>
          </div>
        }
        @if (mode === 'edit') {
          <label class="form-grid-item" for="fileName">Dateiname*</label>
        }
        @if (mode === 'add' && file) {
          <label class="form-grid-item" for="fileName">Ausgewählte Datei*</label>
        }
        @if (mode === 'add' && file) {
          <input type="text" class="form-control form-grid-item"  disabled [value]="file.name">
        }
        @if (mode === 'edit') {
          <input type="text" class="form-control form-grid-item" formControlName="fileName" id="fileName">
        }
        @if (mode === 'edit' && form.get('fileName').hasError('required') && form.get('description').touched) {
          <div class="input-error">Dateiname wird benötigt</div>
        }
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <button (click)="canceled.emit()" class="btn btn-default"><i class="fa fa-long-arrow-left"></i>&nbsp;Zurück</button>&nbsp;
      <button (click)="save()" class="btn btn-primary" [disabled]="!form.valid || !form.dirty || (mode === 'add' && !file)"><i class="fa fa-save"></i>&nbsp;Speichern</button>
    </div>
  </div>

</div>
